<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Materi Klasikal">
            <template slot="extra">
                <a-button type="primary" icon="plus" block @click="showModal('', 'modul')" v-show="this.items.length < 1">
                Tambah Modul
                </a-button>
            </template>
        </a-page-header>

        <a-card type="inner" size="small" >
            <a-form-model :form="form" :model="formData" labelAlign="left">
                <a-table
                    class="pcp-table"
                    :columns="MaterialColumns"
                    :dataSource="tableData"
                    :loading="loading"
                    rowKey="id"
                    :pagination="false"
                    childrenColumnName=""
                    :rowClassName="(r) => r.is_heading ? 'row-heading' : '' "
                    bordered
                >

                    <div slot="no" slot-scope="record" class="text-small text-center" v-show="! record.is_heading && !record.is_child_heading">
                        {{ record.idx }}
                    </div>

                    <div slot="name" slot-scope="record" class="text-small text-left">
                        <template v-if="record.is_heading || record.is_child_heading">
                            <strong v-if="record.is_child_heading">Kategori: </strong>
                            <strong>{{ record.name }}</strong>
                        </template>
                        <template v-else>
                            {{ record.name }}
                        </template>
                    </div>

                    <div slot="order" slot-scope="record" class="text-small text-center">
                        <template v-if="record.is_heading || record.is_child_heading">
                            <strong>{{ record.order }}</strong>
                        </template>
                        <template v-else>
                            {{ record.order }}
                        </template>
                    </div>

                    <div slot="description" slot-scope="record" class="text-small text-left">
                        <template v-if="record.is_heading || record.is_child_heading">
                            <strong>{{ record.description }}</strong>
                        </template>
                        <template v-else>
                            {{ record.description }}
                        </template>
                    </div>

                    <div slot="passing_grade" slot-scope="record" class="text-small text-center">
                        <template v-if="record.is_heading && !record.is_child_heading">
                            <strong>{{ record.passing_grade }}</strong>
                        </template>
                    </div>

                    <div slot="attachment" slot-scope="record" class="text-small text-center">
                        <a-button type="link" size="small" @click="download(record.file)"
                            v-if="record.file != null">
                            <a-icon type="file-pdf" theme="twoTone" two-tone-color="#eb3437" /> Download
                        </a-button>
                    </div>

                    <div slot="exams_count" slot-scope="record" class="text-small text-center">
                        <template v-if="!record.is_heading && !record.is_child_heading">
                            <a-tooltip title="Detail">
                                <a-button
                                    style="margin-right: 4px"
                                    size="small"
                                    @click="showModalDetail(record.id)"
                                > {{ record.exam }}
                                </a-button>
                            </a-tooltip>
                        </template>
                    </div>

                    <div slot="action" slot-scope="record" style="text-align: center">
                        <template v-if="record.is_heading">
                            <a-space>
                                <a-tooltip title="Tambah Kategori">
                                    <a-button size="small" type="primary" icon="plus" @click="showModal('', 'category', record.id)" />
                                </a-tooltip>
                                <a-tooltip title="Edit">
                                    <a-button size="small" type="primary" icon="edit" @click="showModal(record.id, 'modul')" />
                                </a-tooltip>
                            </a-space>
                        </template>
                        <template v-else-if="record.is_child_heading">
                            <a-space>
                                <a-tooltip title="Tambah Materi">
                                    <a-button size="small" type="primary" icon="plus" @click="showModal('', 'material', record.id)" />
                                </a-tooltip>
                                <a-tooltip title="Edit">
                                    <a-button size="small" type="primary" icon="edit" @click="showModal(record.id, 'category', record.parent_id)" />
                                </a-tooltip>
                            </a-space>
                        </template>
                        <template v-else>
                            <a-tooltip title="Edit">
                                <a-button size="small" type="primary" icon="edit" @click="showModal(record.id, 'material', record.parent_id)" />
                            </a-tooltip>
                        </template>
                    </div>

                </a-table>
            </a-form-model>
        </a-card>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visibleModal"
            :closable="false"
            width="50%"
        >
            <classical-material-form :material_id="id" :materiType="materiType" :parentId="parentId" @handleClose="closeModal"/>
        </a-modal>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visibleModalDetail"
            :closable="false"
            width="40%"
        >
            <classical-material-exam :material_id="materialId" @handleClose="closeModalDetail"/>
        </a-modal>
    </div>
</template>

<script>
const MaterialColumns = [
    {
		key: 'no',
		title: 'No',
        align: 'center',
		scopedSlots: {customRender: 'no'},
	},
    {
		key: 'name',
		title: 'Nama',
        align: 'center',
		scopedSlots: {customRender: 'name'},
	}, {
        key: 'order',
        title: 'Order',
        align: 'center',
        scopedSlots: {customRender: 'order'},
    }, {
        key: 'description',
        title: 'Keterangan',
        align: 'center',
        scopedSlots: {customRender: 'description'},
    }, {
        key: 'passing_grade',
        title: 'Passing Grade',
        align: 'center',
        scopedSlots: {customRender: 'passing_grade'},
    }, {
        key: 'attachment',
        title: 'File',
        align: 'center',
        scopedSlots: {customRender: 'attachment'},
    }, {
        key: 'exams_count',
        title: 'Total Ujian',
        align: 'center',
        scopedSlots: {customRender: 'exams_count'},
    }, {
		key: 'action',
		title: 'Action',
		align: 'center',
		scopedSlots: {customRender: 'action'}
	}
]

const ModulsColumns = [
    {
		key: 'name',
		title: 'Nama',
        align: 'center',
		scopedSlots: {customRender: 'name'},
	}, {
        key: 'passing_grade',
        title: 'Passing Grade',
        align: 'center',
        scopedSlots: {customRender: 'passing_grade'},
    }, {
        key: 'order',
        title: 'Order',
        align: 'center',
        scopedSlots: {customRender: 'order'},
    }, {
        key: 'description',
        title: 'Keterangan',
        align: 'center',
        scopedSlots: {customRender: 'description'},
    }, {
		key: 'action',
		title: 'Action',
		align: 'center',
		scopedSlots: {customRender: 'action'}
	}
]

const CategoriesColumns = [
    {
		key: 'name',
		title: 'Nama',
        align: 'center',
		scopedSlots: {customRender: 'name'},
	}, {
        key: 'order',
        title: 'Order',
        align: 'center',
        scopedSlots: {customRender: 'order'},
    }, {
        key: 'description',
        title: 'Keterangan',
        align: 'center',
        scopedSlots: {customRender: 'description'},
    }, {
		key: 'action',
		title: 'Action',
		align: 'center',
		scopedSlots: {customRender: 'action'}
	}
]

const MaterialsColumns = [
    {
		key: 'name',
		title: 'Nama',
        align: 'center',
		scopedSlots: {customRender: 'name'},
	}, {
        key: 'order',
        title: 'Order',
        align: 'center',
        scopedSlots: {customRender: 'order'},
    }, {
        key: 'description',
        title: 'Keterangan',
        align: 'center',
        scopedSlots: {customRender: 'description'},
    }, {
        key: 'attachment',
        title: 'File',
        align: 'center',
        scopedSlots: {customRender: 'attachment'},
    }, {
        key: 'exams_count',
        title: 'Total Ujian',
        align: 'center',
        scopedSlots: {customRender: 'exams_count'},
    }, {
		key: 'action',
		title: 'Action',
		align: 'center',
		scopedSlots: {customRender: 'action'}
	}
]

export default {
    data() {
        return {
            ModulsColumns,
            CategoriesColumns,
            MaterialsColumns,
            MaterialColumns,
            form: this.$form.createForm(this),
            formData: {},
            loading: false,
            items: {
                materials:[]
            },
            visibleModal: false,
            visibleModalDetail: false,
            id: null,
            materiType: '',
            parentId: null,
            materialId: 0
        }
    },
    created() {
        this.getItems()
    },
    computed: {
        tableData() {
            let collection = []

            this.items.materials.forEach(function (item, index) {
                collection.push({
                    idx: 0,
                    id: item.id,
                    name: item.name,
                    description: item.description,
                    order: item.order,
                    passing_grade: item.passing_grade,
                    file: null,
                    exam: null,
                    is_heading: true,
                    is_child_heading: false,
                    parent_id: null
                })

                let idx = 0
            
                item.categories.forEach(function (itemChild, index) {
                    idx++
                    collection.push({
                        idx: idx,
                        id: itemChild.id,
                        name: itemChild.name,
                        description: itemChild.description,
                        order: itemChild.order,
                        passing_grade: null,
                        file: null,
                        exam: null,
                        is_heading: false,
                        is_child_heading: true,
                        parent_id: item.id
                    })

                    let idz = 0

                    itemChild.materials.forEach(function (itemGrand, index) {
                        idz++
                        collection.push({
                            idx: idz,
                            id: itemGrand.id,
                            name: itemGrand.name,
                            description: itemGrand.description,
                            order: itemGrand.order,
                            passing_grade: null,
                            file: itemGrand.attachment,
                            exam: itemGrand.exams_count,
                            is_heading: false,
                            is_child_heading: false,
                            parent_id: itemChild.id
                        })
                    })
                })
            })

            return collection
        }
    },
    methods: {
        getItems(){
            this.loading = true

            this.$http
                .get(this.routeUri('api.material'), {
                    params: {
                        tree: 1
                    }
                })
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        showModal(id, materiType, parentId) {
            this.id = id.toString()
            this.materiType = materiType
            this.parentId = parentId
            this.visibleModal = true
        },
        closeModal(isRefresh) {
            this.visibleModal = false

            if (isRefresh == true) {
                this.getItems()
            }
        },
        download(url) {
            window.open(url, '_blank')
        },
        showModalDetail(materialId) {
            this.materialId = materialId
            this.visibleModalDetail = true
        },
        closeModalDetail() {
            this.visibleModalDetail = false
        },
    },
}
</script>
